import { Link } from 'react-router-dom';
import { CheckCircle2, Eye, MousePointerClick, Radio, Users, Wallet } from 'lucide-react';
import { useAdminOverview } from '@/api/ads/hooks';
import { ResourceGate } from '@/features/ResourceGate';
import { PageHeader } from '@/components/PageHeader';
import { Stat } from '@/components/ui/stat';
import { Card, CardHeader, CardBody } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { npr, num, pct } from '@/lib/format';

export function AdminOverviewPage() {
  const { data, isLoading } = useAdminOverview();
  return (
    <ResourceGate slug="ads.overview">
      <PageHeader title="Ads Overview" description="Platform-wide advertising health." />
      {isLoading ? (
        <Spinner label="Loading overview…" />
      ) : (
        <>
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
            <Stat label="Pending approvals" value={num(data?.pending_approvals)} icon={<CheckCircle2 className="h-4 w-4" />} />
            <Stat label="Active bookings" value={num(data?.active_bookings)} icon={<Radio className="h-4 w-4" />} />
            <Stat label="Advertisers" value={num(data?.advertisers)} icon={<Users className="h-4 w-4" />} />
            <Stat label="Total revenue" value={npr(data?.total_revenue)} icon={<Wallet className="h-4 w-4" />} />
          </div>
          <div className="mt-3 grid grid-cols-2 gap-3 lg:grid-cols-3">
            <Stat label="Impressions" value={num(data?.impressions)} icon={<Eye className="h-4 w-4" />} />
            <Stat label="Clicks" value={num(data?.clicks)} icon={<MousePointerClick className="h-4 w-4" />} />
            <Stat label="CTR" value={pct(data?.ctr_pct ?? 0)} />
          </div>

          <Card className="mt-5">
            <CardHeader title="Quick actions" />
            <CardBody className="flex flex-wrap gap-3">
              <Link to="/admin/approvals">
                <Button>Review approvals</Button>
              </Link>
              <Link to="/admin/rate-card">
                <Button variant="outline">Manage rate card</Button>
              </Link>
              <Link to="/admin/inventory">
                <Button variant="outline">Check inventory</Button>
              </Link>
              <Link to="/admin/reports">
                <Button variant="outline">View reports</Button>
              </Link>
            </CardBody>
          </Card>
        </>
      )}
    </ResourceGate>
  );
}
